<template>
  <AppSection id="vendortimesheets" :title="$getConst.pages.vendor_timesheets.vendor_timesheets_timesheets_title" type="page" >
      <b-form-group id="language" :label="$t($getConst.pages.scope.scopes)" label-for="language-input" v-if="adminRole">
        <multiselect
          v-model="scope"
          track-by="id"
          label="name"
          :placeholder="$t(this.$getConst.pages.form.select_option)"
          :options="scopesOfConnectedRole"
          :show-labels="false"
          :searchable="true"
          @input="changeScope"
          :allowEmpty="false"
        >
          <span slot="noResult">{{$t($getConst.pages.alerts.no_results_found)}}</span>
        </multiselect>
      </b-form-group>
    <AppSection
      id="permissions-table"
      :title="$t($getConst.pages.vendor_timesheets.vendor_timesheets_timesheets_list)"
      type="section"
      :button="hasPermission($getConst.permissions.addInvoice)"
      :button-text="$getConst.pages.button.add"
      :button-icon="$getConst.icons.add"
      second-button
      @onClick="addTimesheet"
      :thirdButton="allDeleted"
      @onClickThirdButton="onDeleteItems"
    >

      <template #secondButton>
        <b-dropdown class="ml-auto" toggle-class="text-success font-weight-bold" variant="link">
          <template #button-content>
            <AppSvgIcon class="mr-2" :icon="$getConst.svgIcons.excel"/>{{$t($getConst.pages.excel.excel) | capitalize}}
          </template>
          <b-dropdown-item-button
            button-class="py-2 font-weight-bold"
            @click="downloadFile"
          >
            {{$t($getConst.pages.excel.export) | capitalize}}<i :class="[$getConst.icons.export, 'ml-2']"/>
          </b-dropdown-item-button>
          <b-dropdown-item-button
            v-if="hasPermission($getConst.permissions.importTimesheets)"
            button-class="py-2 font-weight-bold"
            @click="openPreImportModal"
          >
            {{$t($getConst.pages.excel.import) | capitalize}}<i :class="[$getConst.icons.import, 'ml-2']"/>
          </b-dropdown-item-button>
          <b-dropdown-item-button
            v-if="hasPermission($getConst.permissions.importTimesheetsSpeed)"
            button-class="py-2 font-weight-bold"
            @click="openSpeedImportModal"
          >
            {{$t($getConst.pages.excel.speed_import) | capitalize}}<i :class="[$getConst.icons.import, 'ml-2']"/>
          </b-dropdown-item-button>
        </b-dropdown>
      </template>
      <AppDataTable
        :key="tableKey"
        ref="timesheetsTable"
        :fields="fields"
        :end-point="endPoint"
        :actions="actions"
        @onEdit="editTimesheet"
        @onDelete="confirmDelete"
        @onShow="showDetails"
        :selectable="true"
        :withItem="true"
        :allChecked="checked"
        :headCheckbox="headCheckbox"
        @onCheckedIds="onCheckAllIds"
        @getCheckedIds="onCheckedIds"
        @onAddFilter="filtering"
        @totalItems="getTotalTimesheets"

      >
        <template v-slot:timesheet_submitted_date="item">
          {{formatDate(item.data)}}
        </template>
        <template v-slot:timesheet_approved_date="item">
          {{formatDate(item.data)}}
        </template>
        <template v-slot:timesheet_week_end_date="item">
          {{formatDate(item.data)}}
        </template>
        <template v-slot:client_id="item">
          <template v-if="item.data!=null">
            {{item.data.name}}
          </template>
        </template>
      </AppDataTable>

      <PreImportTimesheetsRapportModal
        :scope-id="scope ? scope.id : null"
        :clients="clients"
        @importedTimesheets="tableKey++"
      />

      <SpeedImportTimesheetsModal
        :scope-id="scope ? scope.id : null"
        :clients="clients"
        @speedImportedTimesheets="tableKey++"
      />

      <AppConfirmationModal
        id="confirmation-modal"
        :title=$t($getConst.pages.profile.are_you_sure) | capitalize
        ref="confirmDelete"
        @onCancel="cancelDelete"
        @onConfirm="deleteTimesheet(false)"/>

      <TimesheetModal
        id="confirm-delete-timesheets"
        :items="this.timesheetToDelete"
        :invoices="invoices_id"
        @deleleTimesheets="deleteTimesheet(true)"
      />

    </AppSection>
  </AppSection>
</template>

<script>
  import AppDataTable from "../../../components/common/table/AppDataTable";
  import AppSection from "../../../components/common/sections/AppSection";
  import {deleteTimesheet,exportTimesheet,getAllStatus} from "../../../api/vendorTimesheets.api";
  import AppConfirmationModal from "../../../components/common/modals/AppConfirmationModal";
  import PreImportTimesheetsRapportModal from "./PreImportTimesheetsRapportModal";
  import SpeedImportTimesheetsModal from "./SpeedImportTimesheetsModal";
  import {getAllScopes, getDefaultScopeIdForList, usersInScopes} from "../../../api/scopes.api";
  import {formatDateByScope} from "../../../shared/services/date";
  import TimesheetModal from "./TimesheetModal";
  import {getEnabledClientByScope} from "../../../api/clients.api";


  export default {
    name: "index",
    components: {TimesheetModal, PreImportTimesheetsRapportModal, SpeedImportTimesheetsModal, AppSection, AppDataTable,AppConfirmationModal},
    data() {
      return {
        invoices_id : [],
        headCheckbox : true,
        fields: [
          {key: 'contractor_name', label:'contractor name', sortable: true, filterable: true},
          {key: 'sub_contractor_name', label:'vendor name', sortable: true, filterable: true},
          {key: 'timesheet_status', label: 'Status', sortable: true, filterable: true},
          {key: 'timesheet_submitted_date', label: 'Submitted date' ,sortable: true, filterable: 'date'},
          {key: 'timesheet_approved_date', label: 'Approved date' ,sortable: true, filterable: 'date'},
          {key: 'timesheet_week_end_date', label: 'Weekend date' ,sortable: true, filterable: 'date'},
          {key: 'client_id', label: 'Client', sortable: true, filterable: true},
        ],
        actions: [
          {
            action: 'onEdit',
            variant: 'outline-secondary',
            icon: this.$getConst.icons.edit,
            permissions: [this.$getConst.permissions.updateTimesheet]
          },
          {
            action: 'onDelete',
            variant: 'outline-danger',
            icon: this.$getConst.icons.delete,
            permissions: [this.$getConst.permissions.deleteTimesheet]
          },
          {
            action: 'onShow',
            variant: 'outline-warning',
            icon: this.$getConst.icons.eye,
            permissions: [this.$getConst.permissions.readVendorTimesheet]
          },
        ],
        tableKey: 0,
        scope: null,
        endPoint: null,
        timesheetToDelete: null,
        status: [],
        scopes: [],
        scopesOfConnectedRole: [],
        adminRole: null,
        checked:false,
        allDeleted:false,
        checkedIds:[],
        filters:{},
        clients:[],
      }
    },
    created() {
      this.getStatus();
      this.endPoint = '/vendors/timesheets';
      this.adminRole=this.isAdmin(this.$store.getters["auth/role"]);
      if (this.adminRole){
        this.getScopes();
      }
      this.getDefaultScopeIdForList();
    },
    methods: {
      getTotalTimesheets(total) {
        this.totalTimesheets = total;
      },
      filtering(filters){
        this.filters = filters
      },
      onDeleteItems(){
        this.confirmDelete(this.checkedIds);
      },
      onCheckedIds(CheckedIds){
        this.checkedIds=CheckedIds;
        this.checkedIds.length==0?this.allDeleted=false:this.allDeleted=true
      },
      onCheckAllIds(el){
        this.checked=el;
      },
      formatDate(date) {
        const formatD = formatDateByScope(date, this.$store.getters["auth/scopeDefault"].format_date, this.scope);
        return formatD;
      },
      getScopes() {
        getAllScopes().then(
          res => {
            this.scopes = res.data;
              this.scopesOfConnectedRole = this.scopes.filter(scope => scope.is_invoices_enabled === true);
          },
          error => this.handleApiError(error)
        );
      },
      getDefaultScopeIdForList() {
        if(this.adminRole){
          getDefaultScopeIdForList().then(
            res => {
              this.scope = res.data;
              if(res.status===204) {
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.no_results_found));
              }
              if(this.scope){
                this.getEnabledClientByScope(this.scope.id)
              }
            },
            error => this.handleApiError(error)
          );
        } else {
          this.scope=this.$store.getters["auth/scopeDefault"];
          if(this.scope){
            this.getEnabledClientByScope(this.scope.id)
          }
        }
      },
      changeScope() {
          this.endPoint = '/vendors/timesheetsinscope/' + this.scope.id;
        this.getEnabledClientByScope(this.scope.id)
      },
      confirmDelete(timesheet) {
        if(!Array.isArray(timesheet)){
          timesheet=[timesheet];
        }
        this.timesheetToDelete = timesheet;
        this.$bvModal.show('confirmation-modal')
      },
      cancelDelete() {
        this.checked=false;
        this.checkedIds=[];
      },
      deleteTimesheet(allDeleted) {
        var ids=[];
        this.timesheetToDelete.forEach(element =>
            ids.push(element.id)
        );
        deleteTimesheet({ids,allDeleted}).then(
          (response) => {
              response.data.deleted.forEach(element => {
                  this.$refs.timesheetsTable.removeItem(element)
                  this.timesheetToDelete=this.timesheetToDelete.filter(el =>el.id !=element.id)
               });
            this.checkedIds=[];
            this.allDeleted=false
            this.checked=false
            this.$refs.confirmDelete.close();
            if( response.data.rejected.length > 0){
              this.invoices_id=response.data.rejected;
              this.$bvModal.show('confirm-delete-timesheets');
            }else {
              this.$snotify.success(this.$t(this.$getConst.pages.vendor.vendor_timesheet_deleted));
              this.$bvModal.hide('confirm-delete-timesheets');
            }
          },
          (error) => {
           this.handleApiError(error);
            this.$refs.confirmDelete.close();
            this.checkedIds=[];
            this.allDeleted=false
          }
        )
      },
      showDetails(timesheet) {
        this.$router.push({name: this.$getConst.routesNames.vendorTimesheetDetails, params: {timesheetId: timesheet.id}});
      },
      downloadFile() {
        if(this.totalTimesheets> 2000) {
          this.$snotify.error(this.$t(this.$getConst.pages.alerts.cannot_export_timesheets));
        }
        else {
        exportTimesheet((this.scope.id), {
          responseType: 'blob',
          headers: {
            'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          }
        },
          this.filters
        ).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const today = new Date();
          const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
          const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
          const dateTime = date + ' ' + time;
          link.setAttribute('download', 'timesheets-' + (this.scope.name) + '-' + dateTime + '.xlsx')
          document.body.appendChild(link);
          link.click();
          window.URL.revokeObjectURL(url);
        },
          (error) => {
            if (error.response.status == '406') {
                this.$snotify.error(this.$t(this.$getConst.pages.alerts.too_large_file));

            }
          });
        }
      },
      addTimesheet() {
        this.$router.push({name: this.$getConst.routesNames.addTimesheet});
      },
      editTimesheet(timesheet) {
        this.$router.push({name: this.$getConst.routesNames.editTimesheet, params: {id: timesheet.id}});
      },
      openPreImportModal() {
        this.$bvModal.show("pre-import-timesheets-rapport")
      },
      openSpeedImportModal() {
        this.$bvModal.show("speed-import-timesheets")
      },
      getStatus() {
        getAllStatus().then(listOfAllStatus => {
          this.status = listOfAllStatus.data.data;
          this.updateStatusField(this.status);
        })
      },
      getEnabledClientByScope(scope_id) {
        getEnabledClientByScope(scope_id).then((res) => {
          this.clients = res.data
          this.updateFields(this.clients);
        })
      },
      updateFields(clients) {
        this.fields[7].filterable = clients.map(client => {
          return {value: client.id, text: client.name};
        });
      },
      updateStatusField(status) {
        this.fields[3].filterable = status.map(status => {
          return {value: status, text: status};
        });
      },
    },

  }
</script>

